export enum TaskWorkflowStatus {
    ToDo = 0,
    Done = 1,
    ReadyForReview = 2,
}
